export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览全部韩国漫画作品' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界的冒险故事' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作韩漫' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常韩漫' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑韩漫' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '感人至深的剧情韩漫' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖韩漫' },
];

export const comics = [
  {
    id: 1,
    title: '秘密花园',
    author: '李智慧',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20with%20two%20lovers%20in%20a%20flower%20garden%2C%20soft%20warm%20lighting%2C%20delicate%20watercolor%20illustration%20style%2C%20gentle%20pastel%20tones%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20clean%20composition%20with%20beautiful%20character%20designs%20and%20floral%20elements&width=600&height=850&seq=comic-cover-01&orientation=portrait',
    rating: 9.5,
    chapters: 128,
    updateDate: '2026-08-04',
    summary: '一段跨越阶级的爱情故事，富家千金与普通画家的偶然相遇，在秘密花园中展开了一段动人心弦的浪漫旅程。',
    tags: ['恋爱', '都市', '治愈'],
    views: 2850000,
    status: '连载中',
  },
  {
    id: 2,
    title: '剑与魔法',
    author: '金泰亨',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20realm%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%20with%20sparkles%2C%20Korean%20webtoon%20art%20style%2C%20dynamic%20composition%2C%20rich%20colors%20with%20golden%20and%20deep%20blue%20accents&width=600&height=850&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    chapters: 96,
    updateDate: '2026-08-03',
    summary: '在剑与魔法并存的世界中，一位平凡少年意外觉醒远古魔力，踏上寻找传说之剑的征程，途中结识伙伴共同对抗黑暗势力。',
    tags: ['奇幻', '冒险', '战斗'],
    views: 2100000,
    status: '连载中',
  },
  {
    id: 3,
    title: '都市猎人',
    author: '朴志勋',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20comic%20cover%20with%20a%20cool%20fighter%20in%20urban%20night%20cityscape%20background%2C%20dynamic%20action%20pose%2C%20neon%20lights%20and%20dark%20alley%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20sharp%20contrast%20lighting%2C%20modern%20urban%20warrior%20theme&width=600&height=850&seq=comic-cover-03&orientation=portrait',
    rating: 9.1,
    chapters: 85,
    updateDate: '2026-08-02',
    summary: '退役特种兵化身都市猎人，在繁华都市的暗处执行各种危险任务，用正义的铁拳粉碎隐藏在城市阴影中的罪恶。',
    tags: ['动作', '都市', '热血'],
    views: 1950000,
    status: '连载中',
  },
  {
    id: 4,
    title: '开心果日记',
    author: '崔美英',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20a%20funny%20girl%20making%20silly%20faces%20in%20a%20bright%20school%20setting%2C%20cheerful%20and%20colorful%20illustration%2C%20Korean%20webtoon%20chibi%20style%2C%20playful%20expressions%2C%20warm%20and%20happy%20atmosphere%2C%20cute%20character%20design&width=600&height=850&seq=comic-cover-04&orientation=portrait',
    rating: 9.0,
    chapters: 72,
    updateDate: '2026-08-05',
    summary: '一个天生自带笑点的女孩的日常生活，从校园到职场，每一页都充满意想不到的笑料和温暖的小确幸。',
    tags: ['搞笑', '日常', '校园'],
    views: 1680000,
    status: '连载中',
  },
  {
    id: 5,
    title: '暗黑追踪',
    author: '郑宇成',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20comic%20cover%20with%20a%20detective%20in%20a%20dark%20rainy%20alley%2C%20mysterious%20silhouette%20in%20the%20background%2C%20noir%20atmosphere%2C%20Korean%20webtoon%20art%2C%20cold%20blue%20tones%20with%20red%20accents%2C%20suspenseful%20mood%2C%20cinematic%20composition&width=600&height=850&seq=comic-cover-05&orientation=portrait',
    rating: 8.9,
    chapters: 64,
    updateDate: '2026-07-30',
    summary: '连环案件接连发生，天才犯罪心理分析师与老练刑警联手追查，一步步揭开隐藏在黑暗中的惊人真相。',
    tags: ['悬疑', '犯罪', '推理'],
    views: 1520000,
    status: '连载中',
  },
  {
    id: 6,
    title: '逆天医仙',
    author: '韩志浩',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20mystical%20healer%20surrounded%20by%20floating%20herbs%20and%20ancient%20symbols%2C%20eastern%20fantasy%20aesthetic%2C%20Korean%20webtoon%20illustration%2C%20ethereal%20green%20and%20gold%20tones%2C%20mystical%20atmosphere%2C%20wise%20character%20design&width=600&height=850&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    chapters: 110,
    updateDate: '2026-08-01',
    summary: '现代医学生穿越到修真世界，凭借现代医学知识结合修真功法，创造出独一无二的医道体系，成为一代传奇医仙。',
    tags: ['奇幻', '修真', '医学'],
    views: 2300000,
    status: '连载中',
  },
  {
    id: 7,
    title: '校园罗曼史',
    author: '孙艺珍',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20school%20romance%20comic%20cover%20with%20a%20couple%20under%20cherry%20blossom%20trees%20in%20school%20uniform%2C%20soft%20pink%20and%20white%20tones%2C%20Korean%20webtoon%20aesthetic%2C%20youthful%20and%20pure%20atmosphere%2C%20delicate%20art%20style%2C%20romantic%20spring%20scene&width=600&height=850&seq=comic-cover-07&orientation=portrait',
    rating: 8.8,
    chapters: 56,
    updateDate: '2026-08-04',
    summary: '高中校园里最不起眼的女孩与全校最受欢迎的男孩之间发生的甜蜜故事，平凡中隐藏着不平凡的青春悸动。',
    tags: ['恋爱', '校园', '青春'],
    views: 1350000,
    status: '连载中',
  },
  {
    id: 8,
    title: '末日求生',
    author: '崔胜贤',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20post%20apocalyptic%20comic%20cover%20with%20a%20survivor%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20Korean%20webtoon%20art%20style%2C%20intense%20survival%20theme%2C%20gritty%20atmosphere%2C%20dynamic%20action%20composition%2C%20rugged%20character%20design&width=600&height=850&seq=comic-cover-08&orientation=portrait',
    rating: 9.0,
    chapters: 78,
    updateDate: '2026-07-29',
    summary: '突如其来的灾难席卷全球，文明崩塌后的幸存者们在废土之上为生存而战，人性的光辉在绝望中闪耀。',
    tags: ['动作', '末日', '生存'],
    views: 1780000,
    status: '连载中',
  },
  {
    id: 9,
    title: '灵异侦探社',
    author: '姜东元',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20comic%20cover%20with%20a%20ghost%20hunter%20in%20a%20haunted%20mansion%2C%20spooky%20atmosphere%20with%20green%20glowing%20eyes%2C%20Korean%20webtoon%20art%2C%20dark%20and%20eerie%20composition%2C%20supernatural%20horror%20theme%2C%20chilling%20mood&width=600&height=850&seq=comic-cover-09&orientation=portrait',
    rating: 8.7,
    chapters: 48,
    updateDate: '2026-07-28',
    summary: '拥有阴阳眼的少年组建灵异侦探社，专门解决各类超自然事件，每一案件背后都隐藏着令人心碎的过往。',
    tags: ['恐怖', '灵异', '侦探'],
    views: 1250000,
    status: '连载中',
  },
  {
    id: 10,
    title: '星光之路',
    author: '金秀贤',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20comic%20cover%20with%20a%20young%20actress%20on%20stage%20under%20spotlight%2C%20theatrical%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20elegant%20and%20emotional%20composition%2C%20warm%20stage%20lighting%2C%20show%20business%20theme&width=600&height=850&seq=comic-cover-10&orientation=portrait',
    rating: 9.4,
    chapters: 90,
    updateDate: '2026-08-05',
    summary: '从默默无闻的练习生到万众瞩目的明星，一个女孩在演艺圈的奋斗史，记录汗水、泪水与梦想交织的成长之路。',
    tags: ['剧情', '演艺圈', '励志'],
    views: 2600000,
    status: '连载中',
  },
  {
    id: 11,
    title: '魔女的条件',
    author: '林允儿',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20with%20a%20witch%20casting%20magic%20in%20a%20mystical%20forest%2C%20magical%20sparkles%20and%20vines%2C%20Korean%20webtoon%20art%2C%20enchanting%20purple%20and%20green%20tones%2C%20fantasy%20witch%20theme%2C%20beautiful%20mystical%20character&width=600&height=850&seq=comic-cover-11&orientation=portrait',
    rating: 8.6,
    chapters: 55,
    updateDate: '2026-07-31',
    summary: '被选为魔女继承者的普通女孩，在魔法学院中面对各种挑战，逐渐发现自己的命运与整个魔法世界息息相关。',
    tags: ['奇幻', '魔法', '学院'],
    views: 1100000,
    status: '连载中',
  },
  {
    id: 12,
    title: '爆笑一家人',
    author: '朴明秀',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20comic%20cover%20with%20a%20chaotic%20family%20of%20five%20making%20funny%20faces%2C%20bright%20and%20colorful%20home%20scene%2C%20Korean%20webtoon%20aesthetic%2C%20warm%20family%20comedy%20theme%2C%20humorous%20expressions%2C%20lively%20illustration&width=600&height=850&seq=comic-cover-12&orientation=portrait',
    rating: 8.5,
    chapters: 102,
    updateDate: '2026-08-02',
    summary: '五口之家的爆笑日常生活，从早餐桌到晚间客厅，每一刻都充满不可预测的搞笑事件，温暖又治愈。',
    tags: ['搞笑', '家庭', '日常'],
    views: 980000,
    status: '连载中',
  },
];

export const hotComics = comics.filter(c => c.rating >= 9.0).slice(0, 8);

export const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);